import { render, staticRenderFns } from "./openSigned.vue?vue&type=template&id=5f637228&scoped=true&"
import script from "./openSigned.vue?vue&type=script&lang=js&"
export * from "./openSigned.vue?vue&type=script&lang=js&"
import style0 from "./openSigned.vue?vue&type=style&index=0&id=5f637228&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f637228",
  null
  
)

export default component.exports